import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 50%;
  text-align: left;
  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    text-transform: capitalize;
    color: var(--color-link);
    margin: 0;
  }
  h4 {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-muted);
    margin: 12px 0 4px;
  }
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: var(--color-text-subtle);
    display: flex;
    grid-gap: 10px;
    align-items: center;
    margin: 12px 0 18px;
    .imgContainer {
      display: block;
      width: 20px;
      height: 20px;
      text-align: center;
    }
  }
  & .largeLineSpace {
    p {
      line-height: 250%;
      margin: 0;
    }
  }
`;
